import trim from 'lodash/trim';
import type { Validator } from './types';

export function makeEmptyValidator(
    message: string = 'Поле содержит только пробельные символы',
): Validator<string> {
    return (value?: string) => (!value || trim(value) !== '' ? undefined : message);
}
